module.exports = __webpack_public_path__ + "img/banner.5eda21a1.png";